import { render } from "./InternalConfigurationsSidebar.vue?vue&type=template&id=57b08a42&scoped=true"
const script = {}

import "./InternalConfigurationsSidebar.vue?vue&type=style&index=0&id=57b08a42&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b08a42"]])

export default __exports__